/**
 * @generated SignedSource<<e20c803526666d25f02254b2feb8a976>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClientNutritionCard_autoNutrition$data = {
  readonly calories: number | null | undefined;
  readonly carbs: number | null | undefined;
  readonly fat: number | null | undefined;
  readonly protein: number | null | undefined;
  readonly " $fragmentType": "ClientNutritionCard_autoNutrition";
};
export type ClientNutritionCard_autoNutrition$key = {
  readonly " $data"?: ClientNutritionCard_autoNutrition$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClientNutritionCard_autoNutrition">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClientNutritionCard_autoNutrition",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "calories",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "carbs",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fat",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "protein",
      "storageKey": null
    }
  ],
  "type": "AutoNutrition",
  "abstractKey": null
};

(node as any).hash = "60dca42793592cd94845d18ac2b6d0dc";

export default node;
